import React from 'react';
import { Card, Typography, Box } from '@mui/material';
import IconPopoverMenu from '../IconPopoverMenu/IconPopoverMenu';
import EditIcon from '../CustomSVGIcons/EditIcon';
import { TLink } from '../../types/global/helper';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { LinkOutlined } from '@mui/icons-material';

export interface IWorkLinkCardProps {
    data: TLink;
    onDelete?: () => void;
    onDuplicate?: () => void;
    onEdit?: () => void;
}

const WorkLinkCard: React.FC<IWorkLinkCardProps> = ({ data: { description, link }, onDelete, onDuplicate, onEdit }) => {
    const { themeStyle } = useThemeContext();
    const handleMenuAction = (action: 'edit' | 'delete' | 'duplicate') => {
        switch (action) {
            case 'delete':
                onDelete && onDelete();
                break;
            case 'duplicate':
                onDuplicate && onDuplicate();
                break;
            case 'edit':
                onEdit && onEdit();
                break;
        }
    };
    return (
        <Card
            sx={{
                display: 'flex',
                alignItems: 'center',
                p: 2,
                maxWidth: '100%',
                position: 'relative',
                my: 1,
                backgroundColor: theme[themeStyle].secondaryBg,
                border: `1px solid ${theme[themeStyle].tag_white}`,
                borderRadius: 2,
                boxShadow: `0px 2px 4px ${theme[themeStyle].shadowColor}`,
                '&:hover': {
                    boxShadow: `0px 4px 8px ${theme[themeStyle].shadowColor}`,
                    border: `1px solid ${theme[themeStyle].highlight}`,
                },
                transition: 'box-shadow 0.2s, border 0.2s',
            }}>
            {/* Left Icon - Link */}
            <LinkOutlined
                sx={{
                    fontSize: 40,
                    mr: 2,
                    color: theme[themeStyle].highlight,
                }}
            />

            {/* Text Content */}
            <Box sx={{ flexGrow: 1 }}>
                <Typography
                    variant="h6"
                    sx={{
                        color: theme[themeStyle].tag_white,
                        fontFamily: 'inherit',
                        fontWeight: 600,
                    }}>
                    {link}
                </Typography>
                <Typography
                    variant="body2"
                    sx={{
                        color: theme[themeStyle].light_gray_text,
                        fontFamily: 'inherit',
                    }}>
                    {description}
                </Typography>
            </Box>

            <Box sx={{ position: 'absolute', top: 8, right: 8 }}>
                <IconPopoverMenu
                    icon={<EditIcon stroke={theme[themeStyle].tag_white} height={'24px'} width={'24px'} />}
                    onOptionClick={handleMenuAction}
                    iconButtonStyle={{
                        color: theme[themeStyle].tag_white,
                    }}
                />
            </Box>
        </Card>
    );
};

export { WorkLinkCard };
